export default "__VITE_ASSET__CY4dv9NM__"